module.exports = __webpack_public_path__ + "static/Museo_Slab_900-webfont-4c544d041a187be6612c0fb8497f5e88.woff2";